import { clinicasApi } from '../../../api';
import { successNotification, dangerNotification } from '../ui';
import { clearNotifications } from '../ui/uiSlice';

export const startAsistencia = (membresia, cita, idConsultaSeguimiento, type) => {
    return async(dispatch) => {

        try {

            dispatch(successNotification('Conectando...'));

            let dataAux = {
                status: false
            };

            if(type === 'onDemand'){

                const { data } = await clinicasApi.post(`/consultas/asistencia/OnDemand?idMembresia=${encodeURIComponent(membresia)}&idCita=${encodeURIComponent(cita)}&asistio=true`);

                dataAux = data;

            }else if(type === 'scheduled'){

                const { data } = await clinicasApi.post(`/citas/asistencias?membresia=${encodeURIComponent(membresia)}&idCita=${encodeURIComponent(cita)}&asistio=true`);

                dataAux = data;

            }else if(type === 'followup'){

                const { data } = await clinicasApi.post(`/consultas/asistencia?idConsultaSeguimiento=${encodeURIComponent(idConsultaSeguimiento)}&asistio=true`);

                dataAux = data;

            }

            if (dataAux.status) {

                dispatch(clearNotifications());
                dispatch(successNotification('Asistencia registrada'));

                return true;

            } else {

                dispatch(clearNotifications());
                dispatch(dangerNotification('Error al registrar asistencia'));

            }

            return false;

        } catch (error) {

            if (typeof error.response !== 'undefined' && typeof error.response.data !== 'undefined' && typeof error.response.data.msg !== 'undefined') {

                dispatch(clearNotifications());
                dispatch(dangerNotification(error.response.data.msg));

            } else {

                dispatch(clearNotifications());
                dispatch(dangerNotification('Error al procesar la petición'));

            }

            return false;

        }

    }
}